import Vue from 'vue';
import ElementBound from '../core/ElementBound';
import VuexStore from './VuexStore';
import { getObject } from 'larasnap/support';
import merge from 'lodash-es/merge';
import uniqueId from 'lodash-es/uniqueId';

export default class extends ElementBound {
    static __larasnap_type = 'vue';
    static __vuex_instance;

    _name;
    _settings = {
        removeWrapper: true,
    };
    _instance;
    _component;
    _app;
    _props;
    _data;
    _id;

    constructor(element, app, settings = {}) {
        super(element);

        this._name = element.data('name');
        this._settings = merge(this._settings, settings);
        this._app = app;
        this._props = element.data('app-props');
        this._data = element.data('app-data');
        this._id = uniqueId('vue-app-');

        $(`<div id="${this._id}"/>`).appendTo(element);

        this.createInstance();
        this.created();

        if (typeof this.constructor.instanceCreated === 'function') {
            this.constructor.instanceCreated(this);
        }

        this.insertInstanceElement();

        if (this._settings.removeWrapper) {
            this._element.children().unwrap();
        }
    }

    insertInstanceElement() {
        // Insert a hidden element into the DOM that is adjacent to the actual vue app and then
        // attach this class instance to the data prop. This will allow for retrieving this
        // instance by searching and locating this element through the DOM
        const placeholder = $(`<div 
                                class="vue-app-instance"
                                data-name="${this._name}"
                                style="display: none"/>`);
        placeholder.insertAfter(this._element);
        placeholder.data('instance', this);
    }

    created() {}

    getData(key = null) {
        return getObject(this._data, key);
    }

    getInstanceProps() {
        return {};
    }

    getAppProps() {
        return {};
    }

    getComponent() {
        return this._component;
    }

    getInstance() {
        return this._instance;
    }

    emit(...args) {
        this._component.$emit(...args);
    }

    createInstance() {
        const props = this.getInstanceProps();

        if (!props.methods) {
            props.methods = {};
        }

        if (this.constructor.store) {
            props.store = new VuexStore(
                this._props,
                this.constructor.store,
            ).create();

            if (typeof this.constructor.storeCreated === 'function') {
                this.constructor.storeCreated(props.store);
            }
        }

        this.addInstanceMethods(props);

        const appProps = merge(this._props, this.getAppProps());

        props.render = h =>
            h(this._app, {
                props: appProps,
            });

        props.el = `#${this._id}`;

        // If this vue app is running inside a panel make sure to destroy the
        // vue instance if the panel is closed
        props.mounted = function () {
            if ($(this.$el).panel()) {
                $(this.$el)
                    .panel()
                    .addHandler('close', () => {
                        this.$destroy();
                    });
            }
        };

        this._instance = new Vue(props); // container instance
        this._component = this._instance.$children[0]; // root component
    }

    addInstanceMethods(props) {
        this.getInstanceMethodNames().forEach(name => {
            if (!props.methods[name]) {
                props.methods[name] = (...args) => {
                    // We want the methods defined for the instance to be executed in
                    // the context of this class instead of the vue instance itself
                    this[name](...args);
                };
            }
        });
    }

    getInstanceMethodNames() {
        const names = Object.getOwnPropertyNames(Object.getPrototypeOf(this));

        return names.reduce((methods, name) => {
            if (name !== 'constructor' && typeof this[name] === 'function') {
                return methods.concat([name]);
            } else {
                return methods;
            }
        }, []);
    }
}
